module.exports = __webpack_public_path__ + "static/media/living-room-2583032_1920.eea67b96.jpg";